// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605051441/js/" + chunkId + "." + {"44":"e4b66432","225":"4f8b8d85","481":"cb84e175","486":"61ecf36c","770":"f96b3620"}[chunkId] + ".0.05243547985738206.chunk.js";
};